export default "__VITE_ASSET__CabQs9yL__"